/**
 * Teil Prompting english translations
 */
export const TEIL_PROMPTING_EN = {
  enhance: 'Enhance',
  enhanceSelectedText: 'Enhance Selected Text',
  makeShorter: 'Make Shorter',
  makeLonger: 'Make Longer',
  customActionPlaceholder: 'Custom action...',
  upgradeRequired: 'Upgrade to Tier 4 required',
  waitForTeilPrompting: 'Wait for current enhancements to finish',
  errorOccurred: 'An error occurred while enhancing the text',
  teilPromptingApplied: 'Enhancement applied',
  generatingTeilPrompting: 'Generating enhancement...',
  corretText: 'Correct Text',
  options: 'Options'
}

/**
 * Teil Prompting german translations
 */
export const TEIL_PROMPTING_DE = {
  enhance: 'Verbessern',
  enhanceSelectedText: 'Ausgewählten Text',
  makeShorter: 'Kürzen',
  makeLonger: 'Verlängern',
  customActionPlaceholder: 'Eigene Aktion...',
  upgradeRequired: 'Upgrade auf Tier 4 erforderlich',
  waitForTeilPrompting: 'Warten Sie, bis die aktuellen partiellen Korrekturen abgeschlossen sind',
  errorOccurred: 'Beim partiellen Korrigieren des Textes ist ein Fehler aufgetreten',
  teilPromptingApplied: 'Partielle Korrektur angewendet',
  generatingTeilPrompting: 'Partielle Korrektur wird generiert...',
  corretText: 'Text korrigieren',
  options: 'Optionen'
}
